import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Trophy, X, History } from 'lucide-react';

// Dati edizioni del torneo (fonte: Wikipedia - CC BY-SA) — fallback locale,
// gestibili anche dal pannello Admin (tab HOME)
export const DEFAULT_EDITIONS = [
  { ed: 'I', date: 'giugno 2003', location: 'Moncalieri', winner: 'Ensi', runnerUp: 'Mondo Marcio', others: 'Principe, Kiffa, Dank, Nema, Shogun, Taiotoshi, Mistaman', note: 'Ensi e Mondo Marcio terminarono la finale a pari merito; nello spareggio definitivo prevalse Ensi.' },
  { ed: 'II', date: '26 giugno 2004', location: 'Patchanka (Chieri)', winner: 'Clementino', runnerUp: 'Rayden', others: 'Bat One, Asher Kuno, Malva, Jesto, Ares Adami, Tesuan, Zeta Tilt, Villano' },
  { ed: 'III', date: '7 dicembre 2005', location: 'Jam Club (Torino)', winner: 'Giankarlo Ira', runnerUp: 'Ares Adami', others: 'Duscian, Rows, Mr. Moka, Hamoon, Don Gocò, Shade, Hari, Karma, Claver Gold, Sbabaman, Dima, Nema, Body, Piuma, Granu' },
  { ed: 'IV', date: '7 dicembre 2006', location: 'Karma Club (Torino)', winner: 'July B', runnerUp: 'Don Diegoh', others: 'MadMan, Morfa, Karma, Ares Adami, Dank, Johnny Killa, Kenzie Kenzei, Albe Ok, Nose, Genesi' },
  { ed: 'V', date: '26 gennaio 2008', location: 'Club Maffia (Reggio Emilia)', winner: 'Emis Killa', runnerUp: 'Kenzie Kenzei', others: 'Freezer, Fedez, Oyoshe, Gelo, Noema, Claver Gold, Moreno, Don Diegoh, Dank, Santiegaz, Canesecco, Endi, Rancore, Jimmy' },
  { ed: 'VI', date: '23 gennaio 2009', location: 'Rising Love (Roma)', winner: 'Noema', runnerUp: 'Moreno', others: 'Deesa, Sbabaman, Agon, Rancore, Tachi, Beks, DJ Tubet, Canesecco, Shoki, Piuma, Black M, Dank, Buzz, Oyoshe, Freezer' },
  { ed: 'VII', date: '13 marzo 2010', location: 'Palazzo Granaio (Milano)', winner: 'Canesecco', runnerUp: 'Moreno', others: 'Dima, Nose, Skarraphone, Dala Pai Pai, Nitro, L\'Elfo, Tachi, Mr. Cioni, Marshall, Zazza, Dank' },
  { ed: 'VIII', date: '26 marzo 2011', location: 'Palazzo Granaio (Milano)', winner: 'Kenzie Kenzei', runnerUp: 'Dari MC', others: 'MS, Nitro, Cili, T-Rabbia, Nepa, Menga, Dosher, Merio, Truffa Player, Trama, Beta, Cypher Vinz, Deesa, Dala Pai Pai, Skarraphone' },
  { ed: 'IX', date: '17 dicembre 2011', location: 'Palazzo Granaio (Milano)', winner: 'Moreno', runnerUp: 'Flam Boy', others: 'Double D, Nerone, Piero Riga, Valerio Nazo, Cypher Vinz, Joker' },
  { ed: 'X', date: '11 maggio 2013', location: 'Hiroshima Mon Amour (Torino)', winner: 'Fatt MC', runnerUp: 'Morbo TDS', others: 'T-Rabbia, Blnkay, Nerone, Virux, MC Nill, L\'Elfo, Kanaglia, Strikkinino, Panico, Risen, Drama, Carbo, Blackson, Thai Smoke, Ill Tofa, Posaman' },
  { ed: 'XI', date: '15 giugno 2014', location: 'Alcatraz (Milano)', winner: 'Lethal V', runnerUp: 'Diskarex', others: 'Madd Eff, Ill Tofa, Papyrus, Nik Riviera, Virux, Imola, Panico, Shark Emcee, Big Tale, Frank the Specialist' },
  { ed: 'XII', date: '31 ottobre 2015', location: 'Mamamia (Senigallia)', winner: 'Morbo TDS', runnerUp: 'Reiven', others: 'Tripla B, Saso, Ghepo, Acros, Black Skull, Deesa, Dr Jack, Drimer, Keso, Dosher, Blnkay, Maik Brain, Panico, Lil Flow' },
  { ed: 'XIII', date: '17 settembre 2016', location: 'Mamamia (Senigallia)', winner: 'Reiven', runnerUp: 'Mouri', others: 'Messia, Shekkero Sho, Palo, Iron Lion, Hydra, Bruno Bug, Posaman, Tullo, Risen, Il Dottore, Keso, Ghepo, Drimer, Black Skull, Madd Eff, Masterman, Frenk, Debbit' },
  { ed: 'XIV', date: '16 settembre 2017', location: 'Mamamia (Senigallia)', winner: 'Shekkero Sho', runnerUp: 'Il Dottore', others: 'Spettro, Trepsol, Posaman, I.Van, Madd Eff, Poomba, Masterman, Frenk, Hydra, Redrum, Blnkay, Gabs, Keso, Bruno Bug' },
  { ed: 'XV', date: '15 settembre 2018', location: 'Mamamia (Senigallia)', winner: 'Blnkay', runnerUp: 'Frenk', others: 'Tullo, Shame, Drimer, Dono, Keso, Resto, Grizzly, Bruno Bug, Snake, Astyce, Simon Skunk, Palo, Redrum, Masterman' },
  { ed: 'XVI', date: '20 settembre 2019', location: 'Alcatraz (Milano)', winner: 'Frenk', runnerUp: 'Hydra', others: 'Tullo, Gabs, Snake, Drimer, Keso, Resto, Grizzly, Bruno Bug, Debbit, Entropia, Redrum, T-Rabbia, Shame, Volperossa' },
  { ed: 'XVII', date: '12 novembre 2022', location: 'Mamamia (Senigallia)', winner: 'Kyn', runnerUp: 'Gabs', others: 'Snake, Efsi9, Casco, Burrito, Alex Mumei, Keies, Cuta, Grizzly, Giuss Dawg, Resto, Mad-San, Alu, Sconer, Higher, Problem One, Misa, Punta, Simon Skunk, Redrum' },
  { ed: 'XVIII', date: '8 dicembre 2023', location: 'Hiroshima Mon Amour (Torino)', winner: 'Higher', runnerUp: 'True Skill', others: 'Giuss Dawg, Paride, Sanji, Redrum, Baga, Cuta, Alex Mumei, Efsi9, Snake, Gabs, Ntufn, Resto, Chiasmo, Sacco, Misa, Lehxon, Vlad, Dikson, Sal Draven' },
  { ed: 'XIX', date: '14 settembre 2024', location: 'Hiroshima Mon Amour (Torino)', winner: 'Redrum', runnerUp: 'Resto', others: 'Tassi, Vinz, Grizzly, Papyrus, Dev, Burrito, Mr. Dice, Spark, Zio Al, Misa, T-Rabbia, Simon Skunk, Marsilio, Ydrow' },
  { ed: 'XX', date: '19 settembre 2025', location: 'Hiroshima Mon Amour (Torino)', winner: 'Grizzly', runnerUp: 'Vlad', others: 'Mr. Dice, Casco, Tassi, Burrito, Keies, Gheb, Misa, Chain, Reyes, Rosso, Punta, Giuss Dawg, TheNigro, Mattoncino, Zenix, Bbiofa' },
];

const EditionsHistoryModal = () => {
  const [open, setOpen] = useState(false);
  const [editions, setEditions] = useState(DEFAULT_EDITIONS);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site-content/editions`)
      .then(r => r.json())
      .then(d => { if (Array.isArray(d.items) && d.items.length) setEditions(d.items); })
      .catch(() => {});
  }, []);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="editions-history-btn"
        className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-gradient-to-r from-red-600 to-red-800 hover:from-red-500 hover:to-red-700 text-white font-bold text-sm sm:text-base shadow-xl transition-all hover:scale-105 border border-red-400/40"
        style={{ fontFamily: 'Oswald, sans-serif', letterSpacing: '0.5px' }}
      >
        <History size={18} />
        TABELLONI SCORSE EDIZIONI
      </button>

      {open && createPortal(
        <div
          role="dialog"
          aria-modal="true"
          aria-label="Tabelloni scorse edizioni Tecniche Perfette"
          data-testid="editions-history-modal"
          className="fixed inset-0 z-[9999] flex items-center justify-center p-3 sm:p-6"
          style={{ backgroundColor: 'rgba(0,0,0,0.9)', backdropFilter: 'blur(10px)' }}
          onClick={() => setOpen(false)}
        >
          <div
            className="relative w-full max-w-6xl max-h-[92vh] rounded-xl overflow-hidden border border-red-600/40 shadow-2xl flex flex-col"
            style={{ backgroundColor: '#0a0a0b' }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between px-4 sm:px-6 py-4 border-b border-gray-800 bg-gradient-to-r from-red-900/30 to-transparent">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-red-600 flex items-center justify-center shrink-0">
                  <Trophy size={20} className="text-white" />
                </div>
                <div>
                  <h3 className="text-lg sm:text-2xl font-bold text-white leading-tight" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '1px' }}>
                    TABELLONI SCORSE EDIZIONI
                  </h3>
                  <p className="text-xs text-gray-400">{editions.length} edizioni — dal 2003 a oggi</p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setOpen(false)}
                data-testid="editions-history-close"
                aria-label="Chiudi"
                className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-gray-800 hover:bg-gray-700 text-white transition-colors shrink-0"
              >
                <X size={20} />
              </button>
            </div>

            {/* Body scrollable */}
            <div className="overflow-y-auto flex-1">
              {/* Desktop table */}
              <div className="hidden md:block">
                <table className="w-full text-sm">
                  <thead className="bg-black sticky top-0 z-10">
                    <tr className="border-b-2 border-red-600">
                      <th className="px-4 py-3 text-left text-red-400 font-bold" style={{ fontFamily: 'Oswald, sans-serif' }}>ED.</th>
                      <th className="px-4 py-3 text-left text-red-400 font-bold" style={{ fontFamily: 'Oswald, sans-serif' }}>DATA FINALE</th>
                      <th className="px-4 py-3 text-left text-red-400 font-bold" style={{ fontFamily: 'Oswald, sans-serif' }}>LOCATION</th>
                      <th className="px-4 py-3 text-left text-yellow-400 font-bold" style={{ fontFamily: 'Oswald, sans-serif' }}>1° POSTO</th>
                      <th className="px-4 py-3 text-left text-gray-300 font-bold" style={{ fontFamily: 'Oswald, sans-serif' }}>2° POSTO</th>
                      <th className="px-4 py-3 text-left text-gray-400 font-bold" style={{ fontFamily: 'Oswald, sans-serif' }}>ALTRI FINALISTI</th>
                    </tr>
                  </thead>
                  <tbody>
                    {editions.map((e, idx) => (
                      <React.Fragment key={e.ed}>
                        <tr
                          className="border-b border-gray-800 hover:bg-red-900/10 transition-colors"
                          style={{ backgroundColor: idx % 2 === 0 ? 'rgba(255,255,255,0.015)' : 'transparent' }}
                        >
                          <td className="px-4 py-3 align-top">
                            <span className="inline-flex items-center justify-center min-w-[36px] h-8 px-2 rounded bg-red-600 text-white font-bold text-sm" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '1px' }}>
                              {e.ed}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-gray-300 align-top whitespace-nowrap">{e.date}</td>
                          <td className="px-4 py-3 text-gray-300 align-top">{e.location}</td>
                          <td className="px-4 py-3 align-top">
                            <span className="inline-flex items-center gap-1.5 text-yellow-400 font-bold">
                              <Trophy size={14} className="shrink-0" />
                              {e.winner}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-gray-200 align-top">{e.runnerUp}</td>
                          <td className="px-4 py-3 text-gray-500 text-xs leading-relaxed align-top">{e.others}</td>
                        </tr>
                        {e.note && (
                          <tr
                            data-testid={`edition-note-${e.ed}`}
                            className="border-b border-gray-800"
                            style={{ backgroundColor: idx % 2 === 0 ? 'rgba(255,255,255,0.015)' : 'transparent' }}
                          >
                            <td colSpan={6} className="px-4 pb-3 pt-0">
                              <p className="text-[11px] text-yellow-300/80 italic leading-relaxed border-l-2 border-yellow-600/60 pl-3">
                                <span className="not-italic font-bold text-yellow-400 mr-1">Nota:</span>
                                {e.note}
                              </p>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Mobile cards */}
              <div className="md:hidden space-y-3 p-3">
                {editions.map((e) => (
                  <div key={e.ed} className="rounded-lg border border-gray-800 p-3" style={{ backgroundColor: 'rgba(255,255,255,0.02)' }}>
                    <div className="flex items-start justify-between mb-2 gap-2">
                      <span className="inline-flex items-center justify-center min-w-[40px] h-8 px-2 rounded bg-red-600 text-white font-bold" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '1px' }}>
                        {e.ed}
                      </span>
                      <div className="text-right">
                        <p className="text-xs text-gray-400">{e.date}</p>
                        <p className="text-xs text-gray-500">{e.location}</p>
                      </div>
                    </div>
                    <div className="space-y-1.5 text-sm">
                      <p className="flex items-center gap-1.5 text-yellow-400 font-bold">
                        <Trophy size={14} className="shrink-0" />
                        {e.winner}
                      </p>
                      <p className="text-gray-300">
                        <span className="text-gray-500 text-xs">2° — </span>
                        {e.runnerUp}
                      </p>
                      <p className="text-gray-500 text-xs leading-relaxed border-t border-gray-800 pt-2 mt-2">
                        <span className="text-gray-400 font-bold">Altri:</span> {e.others}
                      </p>
                      {e.note && (
                        <p className="text-[11px] text-yellow-300/80 italic leading-relaxed border-l-2 border-yellow-600/60 pl-2 mt-2">
                          <span className="not-italic font-bold text-yellow-400 mr-1">Nota:</span>
                          {e.note}
                        </p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Footer */}
            <div className="px-4 sm:px-6 py-3 border-t border-gray-800 bg-black/60 text-center">
              <p className="text-[11px] text-gray-500">
                Fonte dati storici: Wikipedia (CC BY-SA)
              </p>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default EditionsHistoryModal;
